import React from 'react';
import PriceInputWithEarnings, {
  type PriceInputWithEarningsProps,
} from '@wix/da-shared-react/pkg/DollarPriceInput/variants/PriceInputWithEarnings';

import DollarInputController, {
  DollarInputControllerProps,
} from '../../_partials/DollarInputController';

export interface Props
  extends
    Omit<DollarInputControllerProps, 'render'>,
    Omit<
      PriceInputWithEarningsProps,
      // Value is provided by the controller
      keyof DollarInputControllerProps | 'value'
    > {}

const DollarInputFieldWithEarnings: React.FC<Props> = ({ productType, isResale, ...rest }) => {
  return (
    <DollarInputController
      render={fieldProps => (
        <PriceInputWithEarnings productType={productType} isResale={isResale} {...fieldProps} />
      )}
      {...rest}
    />
  );
};
DollarInputFieldWithEarnings.displayName = 'DollarInputFieldWithEarnings';

export default DollarInputFieldWithEarnings;
